module.exports = __webpack_public_path__ + "img/2-Frontline-Walkthrough-One-Page-MVP.40c0e5a1.png";